export default {"src":"/_next/static/media/close-outline.f889e589.svg","height":21,"width":20};